import React from 'react';
import BackButton from '../components/BackButton'

const TermsOfUse = () => {
  return (
    <div className="terms-of-use container mt-2">

<BackButton title="Terms & Conditions" />

      <p><strong>Effective Date: 17 Jan 2024</strong></p>

      <p>
        Welcome to Avatalk AI! These Terms of Use ("Terms") govern your use of the Avatalk AI mobile application ("App"). By using the App, you agree to abide by these Terms. If you do not agree with any part of these Terms, please refrain from using the App.
      </p>

      <h2>1. Grant of License</h2>
      <p>
        Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, and revocable license to use the App solely for personal, non-commercial purposes. You may not sublicense, assign, or transfer this license.
      </p>

      <h2>2. User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Violate any applicable laws or regulations.</li>
        <li>Use the App in a manner that could interfere with, disrupt, negatively affect, or inhibit other users from fully enjoying the App.</li>
        <li>Use the App for any purpose other than its intended purpose of creating avatars using prompts or images.</li>
      </ul>

      <h2>3. Privacy</h2>
      <p>
        Your use of the App is also governed by our 
        <a href="/privacy"> Privacy Policy </a>, which can be found here.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        The App and its content, including but not limited to text, graphics, logos, images, and software, are the property of Avatalk AI or its licensors and are protected by intellectual property laws. You may not modify, reproduce, distribute, or create derivative works based on the App or its content.
      </p>

      <h2>5. Disclaimer of Warranties</h2>
      <p>
        The App is provided "as is" and "as available" without any warranties, express or implied. We do not warrant that the App will meet your requirements, be error-free, or operate without interruption.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by applicable law, Avatalk AI and its affiliates, officers, employees, agents, and licensors shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues.
      </p>

      <h2>7. Termination</h2>
      <p>
        We reserve the right to terminate or suspend your access to the App at our discretion, without notice, for any reason, including, but not limited to, a breach of these Terms.
      </p>

      <h2>8. Changes to Terms</h2>
      <p>
        We reserve the right to update or modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the App after changes are posted constitutes your acceptance of the updated Terms.
      </p>
    </div>
  );
};

export default TermsOfUse;
